module.exports = __webpack_public_path__ + "img/Kirurg-no-logo.9c676136.jpg";